import { jsx as _jsx } from "react/jsx-runtime";
import ErrorMessage from '@jetbrains/ring-ui/components/error-message/error-message';
import artifacts from '@jetbrains/icons/artifacts';
import NavigationLink from '@app/common/navigation/navigation-link';
export default function NotRegisteredNotice({ linkHref, linkMessage, ...restProps }) {
    return (_jsx(ErrorMessage, { icon: artifacts, code: "200", ...restProps, children: _jsx(NavigationLink, { href: linkHref, children: linkMessage }) }));
}
